import { COMPANY } from "@/data";

export default function Footer() {
  return (
    <footer data-testid="footer" className="dark bg-black text-[#F5F4EF] pt-20 pb-10 grain relative">
      <div className="relative z-10 mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="border-t border-white/15 pt-12 grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-8 w-8 bg-primary flex items-center justify-center font-mono-accent text-sm text-white">R</span>
              <span className="font-display text-lg tracking-tight">RICH GLOBAL <span className="text-primary">RMC</span></span>
            </div>
            <p className="text-muted-foreground max-w-xs leading-relaxed">
              Mumbai&apos;s dedicated ready-mix concrete supplier. Batched to spec, delivered 24×7.
            </p>
          </div>
          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-signal-yellow mb-4">Reach us</p>
            <a href={`tel:${COMPANY.phoneRaw}`} className="block text-lg hover:text-primary transition-colors">{COMPANY.phone}</a>
            <a href={`tel:${COMPANY.phone2Raw}`} className="block text-lg hover:text-primary transition-colors">{COMPANY.phone2}</a>
            <a href={`mailto:${COMPANY.email}`} className="block text-lg hover:text-primary transition-colors break-all">{COMPANY.email}</a>
            <a href={`mailto:${COMPANY.email2}`} className="block text-lg hover:text-primary transition-colors break-all">{COMPANY.email2}</a>
            <p className="text-muted-foreground mt-3 leading-relaxed">{COMPANY.address}</p>
          </div>
          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.2em] text-signal-yellow mb-4">Founder</p>
            <p className="font-display text-4xl md:text-5xl font-semibold tracking-tighter leading-none">{COMPANY.founder}</p>
            <p className="font-mono-accent text-xs font-bold uppercase tracking-[0.15em] text-signal-yellow mt-1">{COMPANY.founderTitle}</p>
            <p className="text-muted-foreground mt-3">{COMPANY.hours}</p>
          </div>
        </div>
        <div className="border-t border-white/15 mt-12 pt-6 flex flex-col md:flex-row justify-between gap-3 font-mono-accent text-xs uppercase tracking-[0.15em] text-muted-foreground">
          <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
          <div className="flex items-center gap-6">
            <a data-testid="footer-admin-link" href="/admin/login" className="hover:text-primary transition-colors">Admin</a>
            <span>Mumbai · Mira Bhayandar · 24×7</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
